<template>
  <div>
    <sweet-modal ref="modal" :title="$t('ct-modal-initial-text')" width="700px"  hide-close-button blocking>
      <p>{{ this.$t("ct-modal-initial-obs") }}</p>

      <div class="d-flex justify-content-center text-white">
        <router-link
          class="btn btn-primary"
          target="_blank"
          :to="{
            name: 'SitePages',
            params: { id: site_id },
          }"
        >
          <span>{{ $t("ct-website-list-pages") }}</span>
        </router-link>

        <button
          slot="button"
          @click="closeAction"
          class="btn btn-outline-light mt-2 btn-publish focus"
        >
          {{ this.$t("ct-close") }}
        </button>
      </div>
    </sweet-modal>
  </div>
</template>

<script>
import { SweetModal } from "sweet-modal-vue";
export default {
  props: ["show", "site_id"],
  name: "ModalInitialComponent",
  components: {
    SweetModal,
  },
  watch: {
    show: function (value) {
      if (value) this.$refs.modal.open();
      else this.$refs.modal.close();
    },
  },
  methods: {
    closeAction() {
      this.$emit("closeInitial");
    },
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/dashboard/components/ModalInitial.vue